import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { ATTENDANCE_BRANCHES } from "../config/attendanceBranches";
import { resolveCollectionName } from "./attendanceCollections";

const BRANCH_TO_INDEX = { Main: 0, "Branch 2": 1, "Branch 3": 2 };

/**
 * @param {string} branchFilter — "Main" | "Branch 2" | "Branch 3" (same as Employees / Monthly incentive)
 * @param {string} loginNameOrId — exact EmployeeName (case-insensitive) or employeeId
 * @param {string} pin — must match portalPin on the employee doc
 */
export async function verifyEmployeePortalLogin(branchFilter, loginNameOrId, pin) {
  const idx = BRANCH_TO_INDEX[branchFilter] ?? 0;
  const b = ATTENDANCE_BRANCHES[idx] || ATTENDANCE_BRANCHES[0];
  const col = await resolveCollectionName(b.employeeCandidates || []);
  if (!col) return { ok: false, error: "Employee collection not found for this branch." };

  const needle = String(loginNameOrId || "").trim().toLowerCase();
  const pinIn = String(pin || "").trim();
  if (!needle || !pinIn) return { ok: false, error: "Enter your name or employee ID and your portal PIN." };

  const snap = await getDocs(collection(db, col));
  const matches = [];
  for (const d of snap.docs) {
    const data = d.data() || {};
    const id = String(data.employeeId ?? data.EmployeeId ?? d.id ?? "").trim().toLowerCase();
    const name = String(data.EmployeeName ?? data.employeeName ?? data.name ?? "").trim().toLowerCase();
    if (id === needle || name === needle) {
      matches.push({ docId: d.id, data, collection: col });
    }
  }

  if (matches.length === 0) {
    return { ok: false, error: "No employee found with that name or ID on this branch." };
  }
  if (matches.length > 1) {
    return {
      ok: false,
      error: "More than one match. Please log in with your Employee ID (not name).",
    };
  }

  const { docId, data, collection: empCollectionName } = matches[0];
  const stored = String(data.portalPin ?? data.employeePortalPin ?? "").trim();
  if (!stored) {
    return {
      ok: false,
      error: "Portal PIN is not set on your record yet. Ask HR to add it in Employees.",
    };
  }
  if (stored !== pinIn) {
    return { ok: false, error: "Incorrect PIN." };
  }

  const employeeId = String(data.employeeId ?? data.EmployeeId ?? docId).trim();
  const displayName = String(data.EmployeeName ?? data.employeeName ?? employeeId).trim() || employeeId;

  return {
    ok: true,
    docId,
    empCollectionName,
    employeeId,
    displayName,
    employeeData: data,
  };
}
